var Topic = require('./topic')

var P = require('./parser_constants')
var Device = require('./device')

/**
 * @typedef {Object} TLoginTopicService
 * @property {boolean} linked
 * @property {string} loginType
 * @property {string} url
 * @property {string} [username]
 */

/**
 * Class representing stream login API
 *
 * @constructor
 * @extends Topic
 * @param {BasCore} basCore
 */
function LoginTopic (basCore) {

  Topic.call(this, basCore)

  this.topic = P.LOGIN
}

LoginTopic.prototype = Object.create(Topic.prototype)
LoginTopic.prototype.constructor = LoginTopic

LoginTopic.EVT_SERVICE_UPDATED = 'evtLoginTopicServiceUpdated'

/**
 * Parse a login topic message
 *
 * @param {Object} msg
 */
LoginTopic.prototype.parse = function (msg) {

  var data

  if (msg && msg[P.DATA]) {

    data = msg[P.DATA]

    if (data !== null) {

      this.emit(LoginTopic.EVT_SERVICE_UPDATED, data)
    }
  }
}

/**
 *
 * @param {string} id
 */
LoginTopic.prototype.unlinkStreamingService = function (id) {

  var data

  data = {}
  data[P.ACTION] = P.LOGOUT
  data[P.ID] = id
  return this._request(data)
}

/**
 * List streaming services
 *
 * @returns {Promise<Object<string, TLoginTopicService>>}
 */
LoginTopic.prototype.listStreamingServices = function () {

  var data

  data = {}
  data[P.ACTION] = P.GET_SERVICES

  return this._request(data)
    .then(function (response) {

      if (response?.[P.DATA]) {

        return response[P.DATA]
      }

      return {}
    })
}

/**
 *
 * @param {Object} data
 * @returns {Promise}
 */
LoginTopic.prototype._request = function (data) {

  var msg

  msg = {}
  msg[P.TOPIC] = P.LOGIN
  msg[P.DATA] = data

  return this._basCore.requestV2(msg)
    .then(Device.handleResponse)
}

module.exports = LoginTopic
